export default __webpack_public_path__ + "static/media/tut.3875bd4a.webp";